module.exports = __webpack_public_path__ + "static/media/life-cycle.57430fa9.mp3";